define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("MakePending", _StateAction, {
		m_tag: "MakePending"
	});
});